export const CSRF_COOKIE_NAME = 'TrimbleUnity_reqtkn';
export const CSRF_HEADER_NAME = 'x-TrimbleUnity_csrf';

export class CSRFUtil {

    public static getCSRFHeader(): Record<string, string> | undefined {
        const cookieValue = this.getCookieStringValue(CSRF_COOKIE_NAME);
        if (cookieValue) {
            return { [CSRF_HEADER_NAME]: cookieValue };
        }
        return undefined;
    }

    private static getCookieStringValue(cookieName: string): string | undefined {
        cookieName = cookieName?.toLowerCase() ?? '';
        if (cookieName.length < 1) {
            return undefined;
        }

        const rawValue = document.cookie
            ?.split(';')
            .find(a => a.trim().toLowerCase().startsWith(`${cookieName}=`))
            ?.split('=')
            ?.[1] ?? '';

        if (rawValue.length > 0) {
            return decodeURIComponent(rawValue);
        }
        return undefined;
    }
}
